/* Heretic Coffee Co. — theme behaviour
   One file, no dependencies. Everything is delegated or idempotent so it keeps
   working when Shopify's theme editor re-renders a section. */
(function () {
  'use strict';

  var doc = document;
  var body = doc.body;
  var cfg = window.heretic || {};
  var routes = cfg.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function reduceMotion() { return !!(reduceMQ && reduceMQ.matches); }
  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function bound(el, key) {
    var flag = 'bound' + key;
    if (el.dataset[flag]) return true;
    el.dataset[flag] = '1';
    return false;
  }
  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  /* Page-level events, subscribed once. A hook is tied to an element and is forgotten
     as soon as that element is no longer in the page, so the theme editor can re-render
     a section a hundred times without a hundred listeners piling up behind it. */
  var hooks = { visibility: [], resize: [] };
  function onPage(kind, el, fn) { hooks[kind].push({ el: el, fn: fn }); }
  function firePage(kind) {
    hooks[kind] = hooks[kind].filter(function (h) { return doc.body.contains(h.el); });
    hooks[kind].forEach(function (h) { h.fn(); });
  }
  doc.addEventListener('visibilitychange', function () { firePage('visibility'); });
  /* once per frame at most: a window being dragged wider fires resize dozens of times a second */
  var resizeQueued = false;
  window.addEventListener('resize', function () { if (resizeQueued) return; resizeQueued = true; requestAnimationFrame(function () { resizeQueued = false; firePage('resize'); }); }, { passive: true });

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function focusables(root) {
    return $$(FOCUSABLE, root).filter(function (el) { return el.getClientRects().length > 0; });
  }
  /* Keep Tab inside an open dialog. */
  /* Focus lands on the dialog itself when it opens, as the dialog pattern asks,
     rather than on its close button: a screen reader announces the dialog, Tab
     reaches Close first, and a phone never sees a focus ring it did not ask for. */
  function focusDialog(root) {
    /* the cart and Journal drawers carry role="dialog" on their inner panel, not the wrapper */
    var dialog = root.getAttribute('role') === 'dialog' ? root : root.querySelector('[role="dialog"]') || root;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    dialog.focus({ preventScroll: true });
  }

  function trapTab(e, root) {
    if (e.key !== 'Tab') return;
    var items = focusables(root);
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = doc.activeElement;
    if (e.shiftKey && (active === first || items.indexOf(active) === -1)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Scroll: header over the hero, the what's-playing bar, reading bar   */
  /* ------------------------------------------------------------------ */
  /* One scroll position drives the whole top strip: past TOP_SHIFT the what's-playing
     bar collapses and the header turns solid in the same motion; it all comes back
     near the very top. The gap between the two numbers is deliberate, so a header
     resting right on the boundary can't flicker. */
  var TOP_SHIFT = 80, TOP_RESET = 16;
  var header, hero, progress, articleBody;
  var topShifted = false;
  var scrollQueued = false;

  function refreshRefs() {
    header = $('.site-header');
    var firstSection = $('#MainContent > .shopify-section:first-child');
    hero = firstSection ? firstSection.querySelector('.hero, [data-hero]') : null;
    body.classList.toggle('has-hero', !!hero);
    body.classList.toggle('no-bar', !$('.live'));
    progress = $('[data-read-progress]');
    articleBody = $('[data-article-body]');
  }

  function onScrollFrame() {
    scrollQueued = false;
    var y = window.scrollY || window.pageYOffset || 0;

    if (y > TOP_SHIFT) topShifted = true;
    else if (y < TOP_RESET) topShifted = false;

    body.classList.toggle('scrolled', topShifted);
    /* With no hero behind it the header is always solid. */
    if (header) header.classList.toggle('solid', !hero || topShifted);
    if (progress && articleBody) {
      var rect = articleBody.getBoundingClientRect();
      var offset = window.innerHeight * 0.6;
      var start = rect.top + y - offset;
      var end = rect.bottom + y - offset;
      var p = (y - start) / Math.max(1, end - start);
      progress.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
    }
  }
  function onScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(onScrollFrame);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ------------------------------------------------------------------ */
  /* Menu drawer (full-screen on small screens, side panel on Journal)   */
  /* ------------------------------------------------------------------ */
  var navIsOpen = false;
  var navLastFocus = null;

  function navDrawer() { return doc.getElementById('nav-drawer'); }

  function setNav(open) {
    var drawer = navDrawer();
    var opener = doc.getElementById('nav-open');
    if (!drawer) return;
    navIsOpen = open;
    if (open) {
      navLastFocus = doc.activeElement;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      /* paint the un-inert state once, then run the transition */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!navIsOpen) return;
          drawer.classList.add('is-open');
          focusDialog(drawer);
        });
      });
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      /* next time it opens folded again, except the list holding the page you're on */
      $$('.nav-fold', drawer).forEach(function (f) { var li = f.parentElement, keep = li.hasAttribute('data-fold-current'); li.classList.toggle('is-unfolded', keep); f.setAttribute('aria-expanded', keep ? 'true' : 'false'); });
      drawer.setAttribute('inert', '');
      var back = opener || navLastFocus;
      if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
    }
    if (opener) opener.setAttribute('aria-expanded', String(open));
    body.classList.toggle('nav-open', open);
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */
  var cartIsOpen = false;
  var cartBusy = false;
  var cartLastFocus = null;

  function cartDrawer() { return doc.getElementById('cart-drawer'); }

  function announce(text) {
    var live = $('[data-cart-live]');
    if (!live) return;
    live.textContent = '';
    requestAnimationFrame(function () { live.textContent = text; });
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('count')) el.hidden = n === 0;
    });
    $$('[data-cart-link]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  function showCartError(message) {
    var slot = $('[data-cart-error]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }
  function clearCartError() {
    var slot = $('[data-cart-error]');
    if (slot) slot.hidden = true;
  }

  function openCart(returnTo) {
    var drawer = cartDrawer();
    if (!drawer || cartIsOpen) return;
    cartIsOpen = true;
    cartLastFocus = returnTo || doc.activeElement;
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    body.classList.add('cart-open');
    window.setTimeout(function () { if (cartIsOpen) focusDialog(drawer); }, 60);
  }

  function closeCart() {
    var drawer = cartDrawer();
    if (!drawer || !cartIsOpen) return;
    cartIsOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    body.classList.remove('cart-open');
    clearCartError();
    if (cartLastFocus && typeof cartLastFocus.focus === 'function' && doc.contains(cartLastFocus)) {
      cartLastFocus.focus({ preventScroll: true });
    }
  }

  /* Remember which control had focus so it survives a re-render. */
  function focusMarker(drawer) {
    var el = doc.activeElement;
    if (!el || !drawer.contains(el)) return null;
    if (el.hasAttribute('data-line-step')) return '[data-line-step="' + el.getAttribute('data-line-step') + '"][data-line="' + el.getAttribute('data-line') + '"]';
    if (el.hasAttribute('data-line-remove')) return '[data-line-remove][data-line="' + el.getAttribute('data-line') + '"]';
    if (el.hasAttribute('data-line-qty')) return '[data-line-qty][data-line="' + el.getAttribute('data-line') + '"]';
    return null;
  }

  /* Swap in the section HTML Shopify rendered for us. Same origin, server-rendered. */
  function renderCart(html) {
    var drawer = cartDrawer();
    if (!drawer || typeof html !== 'string') return;
    var marker = focusMarker(drawer);
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-inner]');
    var current = drawer.querySelector('[data-drawer-inner]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    var countEl = drawer.querySelector('[data-cart-count]');
    if (countEl) setCartCount(toInt(countEl.textContent, 0));
    if (cartIsOpen) {
      var target = marker ? drawer.querySelector(marker) : null;
      if (target) target.focus({ preventScroll: true }); else focusDialog(drawer);
    }
  }

  function cartFetch(url, options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = null;
    if (controller) {
      options.signal = controller.signal;
      timer = window.setTimeout(function () { controller.abort(); }, 15000);
    }
    return fetch(url, options).then(function (res) {
      return res.text().then(function (text) {
        var json = null;
        try { json = text ? JSON.parse(text) : {}; } catch (err) { json = null; }
        if (!res.ok || json === null) {
          var error = new Error('Cart request failed');
          error.status = res.status;
          error.payload = json;
          throw error;
        }
        return json;
      });
    }).then(function (json) {
      if (timer) window.clearTimeout(timer);
      return json;
    }, function (err) {
      if (timer) window.clearTimeout(timer);
      throw err;
    });
  }

  function errorMessage(err) {
    var p = err && err.payload;
    if (p && typeof p.description === 'string' && p.description) return p.description;
    if (p && typeof p.message === 'string' && p.message && p.message !== 'Cart Error') return p.message;
    if (err && err.name === 'AbortError') return 'That took too long. Please check your connection and try again.';
    return 'Something went wrong. Please try again.';
  }

  /* Re-read the cart from the server (after an error, or when coming back via the back button). */
  function refreshCart() {
    return cartFetch(routes.cart + '?sections=cart-drawer', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (json) { renderCart(json && json['cart-drawer']); })
      .catch(function () { /* leave what we have */ });
  }

  function changeLine(line, quantity) {
    var drawer = cartDrawer();
    if (!drawer || cartBusy || !line) return;
    cartBusy = true;
    clearCartError();
    drawer.classList.add('is-busy');
    drawer.setAttribute('aria-busy', 'true');
    cartFetch(routes.change + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (json) {
      renderCart(json.sections && json.sections['cart-drawer']);
      announce(quantity === 0 ? 'Item removed. ' + (json.item_count || 0) + ' in cart.' : 'Cart updated. ' + (json.item_count || 0) + ' in cart.');
    }).catch(function (err) {
      showCartError(errorMessage(err));
      return refreshCart();
    }).then(function () {
      cartBusy = false;
      drawer.classList.remove('is-busy');
      drawer.removeAttribute('aria-busy');
    });
  }

  function showFormError(form, message) {
    var slot = form.querySelector('[data-form-error]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }

  /* Add to cart without leaving the page. Delegated so re-rendered forms work too. */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !cartDrawer() || !window.fetch || !window.FormData) return;
    if (form.dataset.submitting) { e.preventDefault(); return; }
    e.preventDefault();

    var btn = form.querySelector('[data-add]');
    var label = btn ? (btn.dataset.label || btn.textContent) : '';
    var returnTo = doc.activeElement && form.contains(doc.activeElement) ? doc.activeElement : btn;
    var slot = form.querySelector('[data-form-error]');
    if (slot) slot.hidden = true;
    form.dataset.submitting = '1';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var raw = new FormData(form);
    var data = new FormData();
    raw.forEach(function (value, key) {
      if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.indexOf('properties[') === 0) data.append(key, value);
    });
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    function restore() {
      delete form.dataset.submitting;
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }

    cartFetch(routes.add + '.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (json) {
        renderCart(json.sections && json.sections['cart-drawer']);
        announce('Added to cart.');
        if (btn) {
          btn.textContent = 'Added';
          window.setTimeout(restore, 1400);
        } else {
          restore();
        }
        openCart(returnTo);
      })
      .catch(function (err) {
        restore();
        showFormError(form, errorMessage(err));
      });
  });

  /* ------------------------------------------------------------------ */
  /* Delegated clicks, changes and keys                                  */
  /* ------------------------------------------------------------------ */
  /* A menu parent ("What we do") opens its list on a press and never navigates; hover
     and keyboard focus open it through CSS. A press anywhere else, or Escape, closes it. */
  function closeSubs(except) {
    $$('.nav-main [data-sub].is-open').forEach(function (sub) {
      if (sub === except) return;
      sub.classList.remove('is-open');
      var b = sub.querySelector('.nav-parent');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    /* in the menus: a parent ("What we do") unfolds its list under it, and folds it again */
    var fold = t.closest('.nav-fold');
    if (fold) {
      var foldOpen = fold.getAttribute('aria-expanded') !== 'true';
      fold.setAttribute('aria-expanded', foldOpen ? 'true' : 'false');
      fold.parentElement.classList.toggle('is-unfolded', foldOpen);
      return;
    }

    var parent = t.closest('.nav-main .nav-parent');
    if (parent) {
      var holder = parent.closest('[data-sub]');
      var open = !holder.classList.contains('is-open');
      closeSubs(holder);
      holder.classList.toggle('is-open', open);
      parent.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!t.closest('.nav-main [data-sub]')) closeSubs(null);

    if (t.closest('#nav-open')) { setNav(true); return; }
    if (t.closest('#nav-close')) { setNav(false); return; }

    var drawer = navDrawer();
    if (drawer && navIsOpen && drawer.contains(t)) {
      /* a tap on the dimmed page closes the Journal side panel */
      if (t === drawer && drawer.classList.contains('jdrawer')) { setNav(false); return; }
      var navLink = t.closest('a');
      if (navLink && !navLink.hasAttribute('data-cart-open')) setNav(false);
    }

    var toggle = t.closest('[data-account-toggle]');
    if (toggle) {
      var show = doc.getElementById(toggle.dataset.accountToggle);
      if (show) {
        $$('.account-panel').forEach(function (panel) { panel.hidden = panel !== show; });
        var first = show.querySelector('input');
        if (first) first.focus();
      }
      return;
    }

    var opener = t.closest('[data-cart-open]');
    if (opener && cartDrawer()) { e.preventDefault(); openCart(); return; }

    var closer = t.closest('[data-cart-close]');
    if (closer) { if (closer.tagName !== 'A') e.preventDefault(); closeCart(); return; }

    var step = t.closest('[data-line-step]');
    if (step) {
      var input = step.parentElement ? step.parentElement.querySelector('input') : null;
      var next = toInt(input ? input.value : '1', 1) + (step.dataset.lineStep === 'up' ? 1 : -1);
      if (next >= 1) changeLine(toInt(step.dataset.line, 0), next); /* the minus stops at one; Remove is the way out */
      return;
    }

    var remove = t.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(toInt(remove.dataset.line, 0), 0); return; }

    var copy = t.closest('[data-copy]');
    if (copy) {
      var original = copy.dataset.originalLabel || copy.textContent;
      copy.dataset.originalLabel = original;
      function done(ok) {
        copy.textContent = ok ? 'Link copied' : 'Copy failed';
        window.setTimeout(function () { copy.textContent = original; }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(copy.dataset.copy || '').then(function () { done(true); }, function () { done(false); });
      } else {
        done(false);
      }
      return;
    }

    var thumb = t.closest('[data-gallery] .thumbs button');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery ? gallery.querySelector('.main img') : null;
      if (main && thumb.dataset.src) {
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        if (thumb.dataset.alt !== undefined) main.alt = thumb.dataset.alt;
      }
      $$('.thumbs button', gallery).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      thumb.setAttribute('aria-pressed', 'true');
      return;
    }

    var stepBtn = t.closest('.qty button[data-step]');
    if (stepBtn) {
      var qtyInput = stepBtn.parentElement ? stepBtn.parentElement.querySelector('input') : null;
      if (!qtyInput) return;
      var min = toInt(qtyInput.min || '1', 1);
      var max = qtyInput.max ? toInt(qtyInput.max, Infinity) : Infinity;
      var value = toInt(qtyInput.value, min) + (stepBtn.dataset.step === 'up' ? 1 : -1);
      qtyInput.value = Math.min(max, Math.max(min, value));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var lineInput = t.closest('[data-line-qty]');
    if (lineInput) {
      /* an emptied or garbled box keeps the quantity it had; only the Remove button sends 0 */
      var typed = parseInt(lineInput.value, 10);
      /* while another change is on its way, a typed number would be dropped: show what the cart holds */
      if (isNaN(typed) || typed < 1 || cartBusy) { lineInput.value = lineInput.defaultValue; return; }
      changeLine(toInt(lineInput.dataset.line, 0), typed); return;
    }

    var sort = t.closest('[data-sort]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
      return;
    }

    var option = t.closest('[data-product-form] .opt input');
    if (option) updateVariant(option.closest('[data-product-form]'), true);
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartIsOpen) { closeCart(); return; }
      if (navIsOpen) { setNav(false); return; }
      var openSub = $('.nav-main [data-sub].is-open');
      if (openSub) { closeSubs(null); var b = openSub.querySelector('.nav-parent'); if (b) b.focus(); return; }
    }
    if (e.key === 'Tab') {
      if (cartIsOpen) { var cd = cartDrawer(); if (cd) trapTab(e, cd.querySelector('.cart-drawer__panel') || cd); return; }
      if (navIsOpen) { var nd = navDrawer(); if (nd) trapTab(e, nd.querySelector('.jdrawer__panel') || nd); }
    }
  });

  /* Coming back with the back button: the page may be restored from cache with a stale cart. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && cartDrawer()) refreshCart();
  });

  /* ------------------------------------------------------------------ */
  /* Product page: variants                                              */
  /* ------------------------------------------------------------------ */
  var variantCache = typeof WeakMap === 'function' ? new WeakMap() : null;

  function variantsFor(form) {
    if (variantCache && variantCache.has(form)) return variantCache.get(form);
    var dataEl = form.querySelector('script[type="application/json"]');
    var list = [];
    if (dataEl) {
      try { list = JSON.parse(dataEl.textContent) || []; } catch (err) { list = []; }
    }
    if (variantCache) variantCache.set(form, list);
    return list;
  }

  function updateVariant(form, syncUrl) {
    if (!form) return;
    var variants = variantsFor(form);
    if (!variants.length) return;
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-add]');
    var priceEl = $('[data-price]');
    var chosen = $$('.opt', form).map(function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
    var variant = variants.find(function (v) {
      return Array.isArray(v.options) && v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!variant) {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? (btn.dataset.label || 'Add to cart') : (btn.dataset.soldout || 'Sold out');
    }
    if (priceEl && typeof variant.price === 'string') priceEl.textContent = variant.price;
    if (!syncUrl) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* URL untouched */ }
  }

  /* ------------------------------------------------------------------ */
  /* Counters                                                            */
  /* ------------------------------------------------------------------ */
  function initCounters(root) {
    $$('[data-today]', root).forEach(function (el) {
      if (bound(el, 'Today')) return;
      try {
        /* the shop's date, whatever time zone the visitor is in: the count beside it is Portland's */
        el.textContent = new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'America/Los_Angeles' });
      } catch (err) { /* leave as rendered */ }
    });

    $$('[data-count]', root).forEach(function (el) {
      var n = toInt(el.dataset.count, NaN);
      if (!isNaN(n)) el.textContent = n.toLocaleString('en-US');
    });

    if (reduceMotion() || !('IntersectionObserver' in window)) return;
    $$('[data-count-group]', root).forEach(function (group) {
      if (bound(group, 'Count')) return;
      var els = $$('[data-count]', group);
      if (!els.length) return;
      var duration = toInt(group.dataset.countDuration, 1600);
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (x) { return x.isIntersecting; })) return;
        io.disconnect();
        /* a count still waiting for the live feed (data-count empty) is counted up by the feed itself */
        els.forEach(function (el) { if (el.dataset.count !== '') tweenCount(el, 0, toInt(el.dataset.count, 0), duration); });
      }, { threshold: 0.35 });
      io.observe(group);
    });
  }

  /* Count an element from one number to another, easing out. The number currently
     showing is remembered per element, so a later change starts from what the reader
     actually sees rather than jumping. */
  var counting = typeof WeakMap === 'function' ? new WeakMap() : null;
  function shownCount(el, fallback) {
    var st = counting && counting.get(el);
    return st && typeof st.shown === 'number' ? st.shown : fallback;
  }
  function tweenCount(el, from, to, duration) {
    var st = (counting && counting.get(el)) || {};
    if (st.frame) cancelAnimationFrame(st.frame);
    if (reduceMotion() || duration <= 0 || from === to) {
      el.textContent = to.toLocaleString('en-US');
      if (counting) counting.set(el, { shown: to, frame: null });
      return;
    }
    var start = null;
    function step(t) {
      if (!el.isConnected) return;
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      var n = Math.round(from + (to - from) * eased);
      el.textContent = n.toLocaleString('en-US');
      if (counting) counting.set(el, { shown: n, frame: p < 1 ? requestAnimationFrame(step) : null });
    }
    if (counting) counting.set(el, { shown: from, frame: requestAnimationFrame(step) }); else requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------------ */
  /* The roast log: the log slides in and the chart draws itself once    */
  /* it scrolls into view. Nothing is hidden until this has run, so the  */
  /* page reads fine without it, and reduced motion leaves it be.        */
  /* ------------------------------------------------------------------ */
  function initRoastLog(root) {
    $$('[data-roast-anim]', root).forEach(function (box) {
      if (bound(box, 'Roast')) return;
      if (reduceMotion() || !('IntersectionObserver' in window)) return;
      var reveal = $('[data-roast-reveal]', box);
      var full = reveal ? parseFloat(reveal.getAttribute('width')) || 1012 : 0;
      box.classList.add('roast--armed');
      if (reveal) reveal.setAttribute('width', '0');

      var played = false;
      function play() {
        if (played) return;
        played = true;
        box.classList.add('roast--in');
        if (!reveal) return;
        /* the lines draw a little after the log starts moving, over about the time a
           reader needs to find the chart, and finish in one go under reduced motion */
        var duration = 2600, delay = 350, start = null;
        function step(t) {
          if (!reveal.isConnected) return;
          if (start === null) start = t;
          var p = Math.min(1, Math.max(0, (t - start - delay) / duration));
          if (reduceMotion()) p = 1;
          var eased = 1 - Math.pow(1 - p, 2);
          reveal.setAttribute('width', String(Math.round(full * eased * 10) / 10));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      /* Plays once a quarter of the chart is in view. After that it keeps watching only to
         pause the drop marker's looping pulse while the chart is off screen. */
      var io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        if (e.isIntersecting && e.intersectionRatio >= 0.25) play();
        if (played) box.classList.toggle('roast--off', !e.isIntersecting);
      }, { threshold: [0, 0.25] });
      io.observe(box);
    });
  }

  /* Rows that scroll sideways on a phone (the coffee bags, the Journal) open on their
     first card. iPhone Safari can start such a row part-way along (it re-snaps to a
     middle card while photos load, or brings back an old position), so until the
     reader swipes the row sideways themselves, any scroll it makes on its own is undone.
     A vertical swipe that starts on the row does not count as touching it. */
  function initRowStart(root) {
    $$('[data-row-start]', root).forEach(function (row) {
      if (bound(row, 'RowStart')) return;
      var mine = false, x0 = 0, y0 = 0;
      function home() { if (!mine && row.scrollLeft !== 0) row.scrollLeft = 0; }
      row.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      row.addEventListener('touchmove', function (e) {
        var t = e.touches[0], dx = Math.abs(t.clientX - x0), dy = Math.abs(t.clientY - y0);
        if (dx > 6 && dx > dy) mine = true;
      }, { passive: true });
      row.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) mine = true; }, { passive: true });
      row.addEventListener('keydown', function () { mine = true; });
      row.addEventListener('mousedown', function () { mine = true; });
      row.addEventListener('focusin', function () { mine = true; });
      row.addEventListener('scroll', function () { if (!mine) requestAnimationFrame(home); }, { passive: true });
      $$('img', row).forEach(function (img) { if (!img.complete) img.addEventListener('load', home); });
      window.addEventListener('load', home);
      window.addEventListener('pageshow', home);
      home();
    });
  }

  /* Sheets: the small pop-ups (the plain-words explainer under the roast log, an
     origin's story on the map). A native dialog, opened and closed with a short
     rise and fade. Escape, the Close button and the backdrop all close it. Any
     element with data-sheet="<dialog id>" opens that dialog. */
  function initSheets(root) {
    $$('[data-sheet]', root).forEach(function (btn) {
      if (bound(btn, 'Sheet')) return;
      var dialog = doc.getElementById(btn.dataset.sheet);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      btn.classList.add('is-ready');
      btn.addEventListener('click', function (e) {
        /* a link to #<sheet> opens it here and keeps the address shareable, without jumping */
        if (btn.tagName === 'A') {
          e.preventDefault();
          try { history.replaceState(null, '', '#' + dialog.id); } catch (err) { /* address unchanged */ }
        }
        openSheet(dialog);
      });
      /* arriving on a link to the sheet (another page's #<sheet>): bring its button into view and open it */
      if (btn.tagName === 'A' && decodeURIComponent((location.hash || '').slice(1)) === dialog.id && !dialog.open) {
        setTimeout(function () { if (dialog.open) return; btn.scrollIntoView({ block: 'center' }); openSheet(dialog); }, 350);
      }
      if (bound(dialog, 'SheetDialog')) return;
      var closing = false;

      function close() {
        if (!dialog.open || closing) return;
        closing = true;
        dialog.classList.remove('is-in');
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          if (dialog.open) dialog.close();
        }
        if (reduceMotion()) { finish(); return; }
        /* only the sheet's own fade counts: a button inside it ending its hover colour
           must not cut the close short */
        function ended(e) { if (e.target !== dialog) return; dialog.removeEventListener('transitionend', ended); finish(); }
        dialog.addEventListener('transitionend', ended);
        setTimeout(function () { dialog.removeEventListener('transitionend', ended); finish(); }, 700);
      }

      $$('[data-sheet-close]', dialog).forEach(function (x) { x.addEventListener('click', close); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      dialog.addEventListener('close', function () {
        closing = false;
        dialog.classList.remove('is-in');
        body.classList.remove('help-open');
      });
    });
  }
  function openSheet(dialog) {
    if (dialog.open) return;
    dialog.showModal();
    /* showModal puts focus on Close, which paints a focus ring on a phone tap */
    focusDialog(dialog);
    body.classList.add('help-open');
    /* two frames: one for the dialog to be laid out closed, one for the transition to start */
    requestAnimationFrame(function () { requestAnimationFrame(function () { dialog.classList.add('is-in'); }); });
  }

  /* ------------------------------------------------------------------ */
  /* Where does this coffee come from: one tile per region. The tiles    */
  /* enter like the roast log (slide in, then the pins pop in) once they */
  /* scroll into view; a pin or its chip leans its tile in toward that   */
  /* origin while the sheet is open, and lets go on close.               */
  /* ------------------------------------------------------------------ */
  function initOriginMap(root) {
    $$('[data-omap-anim]', root).forEach(function (wrap) {
      if (bound(wrap, 'OriginMap')) return;
      var tiles = $$('[data-origin-map]', wrap);
      var section = wrap.closest('section') || wrap.parentNode;
      var pins = $$('[data-omap-pin]', wrap);
      var chips = $$('[data-omap-chip]', section);
      /* two pins close together: their labels must not sit on top of each other */
      function hits(a, b, pad) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return ra.left < rb.right + pad && ra.right > rb.left - pad && ra.top < rb.bottom + pad && ra.bottom > rb.top - pad; }
      /* labels: two pins close together flip one name to the other side and shrink their
         tap areas; a town name under a pin, its name or another town gets out of the way.
         Measured again when the width changes (a phone turning sideways). */
      function layoutLabels() {
        pins.forEach(function (pin) { pin.classList.remove('omap__pin--left', 'omap__pin--tight'); });
        pins.forEach(function (pin) { if (parseFloat(pin.style.getPropertyValue('--x')) > 72) pin.classList.add('omap__pin--left'); });
        pins.forEach(function (pin, i) {
          var a = pin.querySelector('.omap__label'); if (!a) return;
          for (var j = 0; j < i; j++) {
            var b = pins[j].querySelector('.omap__label'); if (!b || pins[j].parentNode !== pin.parentNode) continue;
            if (hits(a, b, 6)) pin.classList.toggle('omap__pin--left');
            if (hits(pin, pins[j], 0)) { pin.classList.add('omap__pin--tight'); pins[j].classList.add('omap__pin--tight'); }
          }
        });
        var shown = [];
        $$('.otile__city', wrap).forEach(function (city) {
          city.classList.remove('is-crowded');
          var crowded = pins.some(function (pin) { if (pin.parentNode !== city.parentNode) return false; var label = pin.querySelector('.omap__label'); return hits(city, pin.querySelector('.omap__dot') || pin, 8) || (label && hits(city, label, 4)); })
            || shown.some(function (other) { return other.parentNode === city.parentNode && hits(city, other, 4); });
          city.classList.toggle('is-crowded', crowded);
          if (!crowded) shown.push(city);
        });
      }
      function measure() { if (wrap.getBoundingClientRect().width) layoutLabels(); }
      measure();
      /* the names are measured in the real fonts once they arrive */
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      var lastW = window.innerWidth;
      onPage('resize', wrap, function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; measure(); });
      function setActive(key) {
        pins.forEach(function (p) { p.classList.toggle('is-active', !!key && p.dataset.omapPin === key); });
        chips.forEach(function (c) { c.classList.toggle('is-active', !!key && c.dataset.omapChip === key); });
        tiles.forEach(function (tile) {
          var stage = tile.querySelector('[data-omap-stage]');
          var pin = key ? $$('[data-omap-pin]', tile).filter(function (p) { return p.dataset.omapPin === key; })[0] : null;
          if (pin && stage) stage.style.transformOrigin = pin.style.getPropertyValue('--x') + ' ' + pin.style.getPropertyValue('--y');
          tile.classList.toggle('omap--zoomed', !!pin);
        });
      }
      pins.concat(chips).forEach(function (el) {
        var key = el.dataset.omapPin || el.dataset.omapChip;
        var dialog = doc.getElementById(el.dataset.sheet || '');
        el.addEventListener('click', function () { setActive(key); });
        if (dialog && !bound(dialog, 'OriginMapDialog')) dialog.addEventListener('close', function () { setActive(null); });
      });
      /* the entrance, armed only when it can play; nothing is hidden otherwise */
      if (reduceMotion() || !('IntersectionObserver' in window) || !tiles.length) return;
      wrap.classList.add('omap--armed');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (x) { return x.isIntersecting; })) return;
        io.disconnect();
        wrap.classList.add('omap--in');
        /* once the tiles and pins have arrived, drop the entrance classes so the pins'
           ordinary behaviour (dimming and settling with no stagger) takes over */
        setTimeout(function () { wrap.classList.remove('omap--armed', 'omap--in'); }, 2600);
      }, { threshold: 0.2 });
      io.observe(tiles[0]);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Financial transparency: the columns rise in as the section arrives. */
  /* ------------------------------------------------------------------ */
  function initFin(root) {
    $$('[data-fin]', root).forEach(function (fin) {
      if (bound(fin, 'Fin')) return;
      var section = fin.closest('section') || fin;
      if (reduceMotion() || !('IntersectionObserver' in window)) return;
      section.classList.add('fin--armed');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (x) { return x.isIntersecting; })) return;
        io.disconnect();
        section.classList.add('fin--in');
      }, { threshold: 0.2 });
      io.observe(fin);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Background footage: in the hero or behind a section. Muted, paused  */
  /* offscreen or in a hidden tab, and still for reduced motion. Section */
  /* footage is marked preload="none" and is only fetched once it comes  */
  /* within a screen of the viewport, so the page itself stays light.    */
  /* ------------------------------------------------------------------ */
  function initBackgroundVideo(root) {
    $$('.hero video, .sec-media video, .arch video', root).forEach(function (video) {
      if (bound(video, 'Video')) return;
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      if (reduceMotion() || saveData) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      var waiting = video.getAttribute('preload') === 'none';
      function fetchNow() { if (!waiting) return; waiting = false; video.preload = 'auto'; video.load(); }
      function play() { fetchNow(); var p = video.play(); if (p && p.catch) p.catch(function () { /* autoplay refused; poster stays */ }); }
      var visible = true;
      if ('IntersectionObserver' in window) {
        if (waiting) {
          new IntersectionObserver(function (entries, io) {
            if (entries[0].isIntersecting) { fetchNow(); io.disconnect(); }
          }, { rootMargin: '100% 0px' }).observe(video);
        }
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible && !doc.hidden) play(); else video.pause();
        }, { threshold: 0.1 }).observe(video);
      } else {
        play();
      }
      onPage('visibility', video, function () {
        if (doc.hidden) video.pause(); else if (visible) play();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Hero stand-in: steam and an ember glow until footage is uploaded    */
  /* ------------------------------------------------------------------ */
  function initSteam(root) {
    $$('canvas[data-steam]', root).forEach(function (canvas) {
      if (bound(canvas, 'Steam')) return;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var still = reduceMotion() || saveData;
      var W = 0, H = 0, puffs = [], grain = null, grainPattern = null, visible = true, animating = false, fitQueued = false;

      function makeGrain() {
        var g = doc.createElement('canvas');
        g.width = g.height = 180;
        var gx = g.getContext('2d');
        var img = gx.createImageData(180, 180);
        for (var i = 0; i < img.data.length; i += 4) {
          var v = Math.random() * 255;
          img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
          img.data[i + 3] = 22;
        }
        gx.putImageData(img, 0, 0);
        return g;
      }

      function resize() {
        fitQueued = false;
        W = canvas.clientWidth; H = canvas.clientHeight;
        if (!W || !H) return;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        puffs = [];
        var n = Math.round(Math.max(14, Math.min(40, W / 60)));
        for (var i = 0; i < n; i++) {
          puffs.push({ x: Math.random() * W, y: H * 0.35 + Math.random() * H * 0.8, r: 80 + Math.random() * 180, vy: 0.12 + Math.random() * 0.35, vx: (Math.random() - 0.5) * 0.25, a: 0.03 + Math.random() * 0.05, ph: Math.random() * 6.28 });
        }
        if (still) draw(0);
      }

      var lastT = null;
      function draw(t) {
        /* motion follows the clock, not the frame count, so the drift is the same speed on a
           60 Hz laptop and a 120 Hz phone (k = 1 at 60 frames a second) */
        var k = lastT === null ? 1 : Math.min(4, (t - lastT) / 16.67);
        lastT = t;
        ctx.fillStyle = '#1c1714';
        ctx.fillRect(0, 0, W, H);
        var pulse = 0.85 + 0.15 * Math.sin(t / 2600);
        var ember = ctx.createRadialGradient(W * 0.5, H * 1.05, 10, W * 0.5, H * 1.05, Math.max(W, H) * 0.75);
        ember.addColorStop(0, 'rgba(193,50,26,' + (0.75 * pulse) + ')');
        ember.addColorStop(0.35, 'rgba(150,52,24,.35)');
        ember.addColorStop(1, 'rgba(28,23,20,0)');
        ctx.fillStyle = ember;
        ctx.fillRect(0, 0, W, H);
        var night = ctx.createRadialGradient(W * 0.15, H * 0.1, 10, W * 0.15, H * 0.1, W * 0.6);
        night.addColorStop(0, 'rgba(30,41,64,.55)');
        night.addColorStop(1, 'rgba(30,41,64,0)');
        ctx.fillStyle = night;
        ctx.fillRect(0, 0, W, H);
        puffs.forEach(function (p) {
          if (!still) {
            p.y -= p.vy * k;
            p.x += (p.vx + Math.sin(t / 3000 + p.ph) * 0.2) * k;
            if (p.y + p.r < -20) { p.y = H + p.r; p.x = Math.random() * W; }
          }
          var steam = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
          steam.addColorStop(0, 'rgba(244,236,221,' + p.a + ')');
          steam.addColorStop(1, 'rgba(244,236,221,0)');
          ctx.fillStyle = steam;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, 6.283);
          ctx.fill();
        });
        if (!grain) grain = makeGrain();
        /* the grain pattern is built once; only its offset changes from frame to frame */
        if (!grainPattern) grainPattern = ctx.createPattern(grain, 'repeat');
        var ox = still ? 0 : (Math.random() * 180) | 0;
        var oy = still ? 0 : (Math.random() * 180) | 0;
        ctx.save();
        ctx.translate(-ox, -oy);
        ctx.fillStyle = grainPattern;
        ctx.fillRect(0, 0, W + 180, H + 180);
        ctx.restore();
      }

      /* steam drifts slowly, so 30 frames a second looks the same as 60 or 120 and costs a
         half to a quarter of the drawing */
      var lastDraw = 0;
      function frame(t) {
        if (!canvas.isConnected || still || !visible || doc.hidden) { animating = false; lastT = null; return; }
        if (!t || t - lastDraw >= 32) { lastDraw = t || 0; draw(t || 0); }
        requestAnimationFrame(frame);
      }
      function wake() {
        if (animating || still) return;
        animating = true;
        requestAnimationFrame(frame);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) wake();
        }).observe(canvas);
      }
      onPage('visibility', canvas, function () { if (!doc.hidden) wake(); });
      onPage('resize', canvas, function () {
        if (fitQueued) return;
        fitQueued = true;
        requestAnimationFrame(resize);
      });
      resize();
      if (still) draw(0); else wake();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Donate button: if the Givebutter widget never arrives, show a link  */
  /* ------------------------------------------------------------------ */
  function initGivebutter(root) {
    $$('[data-givebutter-fallback]', root).forEach(function (link) {
      if (bound(link, 'Givebutter')) return;
      var widget = link.previousElementSibling;
      function reveal() {
        link.hidden = false;
        if (widget && widget.tagName && widget.tagName.toLowerCase() === 'givebutter-widget') widget.hidden = true;
      }
      if (!window.customElements) { reveal(); return; }
      var settled = false;
      window.customElements.whenDefined('givebutter-widget').then(function () { settled = true; });
      window.setTimeout(function () { if (!settled && !window.customElements.get('givebutter-widget')) reveal(); }, 5000);
    });
  }

  /* ------------------------------------------------------------------ */
  /* One poller per source: Spotify, Last.fm and the people-fed feed     */
  /* ------------------------------------------------------------------ */
  /* The strip, the counters and the LIVE board all want the same two answers. Each
     source is fetched by one timer for the whole page, at the pace of the most eager
     reader that is currently watching (the strip's 20 seconds for Last.fm; 45 seconds
     for the feed while the board is open, 60 otherwise), and every reader gets the same
     answer at the same moment, so the page never shows two different counts or two
     different song ages. A failed fetch keeps the last answer and retries sooner, then
     more slowly. Nothing is fetched while the tab is hidden; coming back fetches only
     what has gone stale. The board (live-board.js) reads through window.HereticLive. */
  var Live = (function () {
    var sources = {};

    /* "how long ago", one wording for the whole site */
    function ago(thenMs, nowMs) {
      var m = Math.round(((nowMs || Date.now()) - thenMs) / 60000);
      if (!isFinite(m)) return '';
      if (m < 1) return 'just now';
      if (m < 60) return m + ' min ago';
      var h = Math.round(m / 60);
      if (h < 24) return h + (h === 1 ? ' hr ago' : ' hrs ago');
      var d = Math.round(h / 24);
      return d === 1 ? 'yesterday' : d + ' days ago';
    }

    function fetchJSON(url, ms) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var cutoff = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms);
      return fetch(url, { signal: ctrl ? ctrl.signal : undefined, cache: 'no-store', credentials: 'omit', referrerPolicy: 'strict-origin-when-cross-origin' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(function (d) { clearTimeout(cutoff); return d; }, function (e) { clearTimeout(cutoff); throw e; });
    }

    function field(v) { return typeof v === 'string' ? v : (v && (v['#text'] || v.name)) || ''; }
    /* Last.fm's answer reduced to what anyone shows: the song on now and up to four before it */
    function parseLastfm(data) {
      if (!data || data.error || !data.recenttracks) return null;
      var list = data.recenttracks.track;
      if (list == null) list = [];
      if (!Array.isArray(list)) list = [list];
      var now = null, played = [];
      list.forEach(function (t) {
        if (!t) return;
        var entry = { artist: field(t.artist), title: field(t.name), uts: t.date ? parseInt(t.date.uts, 10) || 0 : 0 };
        if (!entry.artist && !entry.title) return;
        if (t['@attr'] && t['@attr'].nowplaying === 'true') { if (!now) now = entry; }
        else if (played.length < 4) played.push(entry);
      });
      return { now: now, played: played };
    }
    function lastfmUrl(user, key) {
      return 'https://ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&format=json&limit=5' +
        '&user=' + encodeURIComponent(user) + '&api_key=' + encodeURIComponent(key);
    }
    function feedUrl(raw) { return String(raw || '').replace(/\/+$/, '') + '/'; }
    /* the same worker's /music: what the shop's Spotify account is playing */
    function musicUrl(raw) { return feedUrl(raw) + 'music'; }

    /* The worker's /music answer, checked field by field: only text, times and https art pass. */
    function song(t) {
      if (!t || typeof t !== 'object') return null;
      var artist = typeof t.artist === 'string' ? t.artist : '', title = typeof t.title === 'string' ? t.title : '';
      if (!artist && !title) return null;
      return { artist: artist, title: title, uts: typeof t.uts === 'number' && isFinite(t.uts) ? Math.floor(t.uts) : 0, art: typeof t.art === 'string' && /^https:\/\//i.test(t.art) ? t.art : '' };
    }
    /* An answer the worker couldn't refresh (Spotify down, or asking it to wait) says how old it
       is; past three minutes the song it had on may well have ended, so it isn't "on now". */
    var SPOTIFY_NOW_FOR = 180;
    function parseSpotify(d) {
      if (!d || typeof d !== 'object' || !('now' in d)) return null;
      var old = d.stale === true || (typeof d.age_seconds === 'number' && d.age_seconds > SPOTIFY_NOW_FOR);
      return {
        now: old ? null : song(d.now),
        played: (Array.isArray(d.played) ? d.played : []).map(song).filter(Boolean).slice(0, 4),
        count: typeof d.count === 'number' && isFinite(d.count) && d.count >= 0 ? Math.round(d.count) : null,
        playlist: playlistOf(d.playlist),
      };
    }
    /* the day's playlist on the shop's Spotify: only a real open.spotify.com link, for a dated day */
    function playlistOf(p) {
      if (!p || typeof p !== 'object' || typeof p.url !== 'string' || !/^https:\/\/open\.spotify\.com\/playlist\/[A-Za-z0-9]+/.test(p.url) || !/^\d{4}-\d{2}-\d{2}$/.test(String(p.day))) return null;
      return { day: String(p.day), url: p.url, name: typeof p.name === 'string' ? p.name : '', count: typeof p.count === 'number' && p.count > 0 ? Math.round(p.count) : 0 };
    }

    function source(kind, url) {
      var id = kind + ' ' + url;
      if (!sources[id]) sources[id] = { kind: kind, url: url, watchers: [], data: null, at: 0, failures: 0, timer: 0, busy: false };
      return sources[id];
    }
    /* readers whose element has left the page (an editor re-render) are forgotten */
    function prune(s) { s.watchers = s.watchers.filter(function (w) { return !w.stopped && (!w.owner || doc.body.contains(w.owner)); }); }
    function pace(s) {
      prune(s);
      var wanted = s.watchers.filter(function (w) { return w.active; }).map(function (w) { return w.every; });
      return wanted.length ? Math.min.apply(null, wanted) : 0;
    }
    function retryWait(s, base) {
      if (s.kind === 'lastfm') return s.failures === 1 ? 8000 : s.failures === 2 ? 20000 : base * Math.min(4, s.failures - 1);
      return base * Math.pow(2, Math.min(s.failures, 4));
    }
    function schedule(s) {
      clearTimeout(s.timer); s.timer = 0;
      var base = pace(s);
      if (!base || doc.hidden || s.busy) return;
      var wait = s.failures ? retryWait(s, base) : Math.max(0, base - (Date.now() - s.at));
      s.timer = setTimeout(function () { load(s); }, wait);
    }
    function tell(w, s) {
      try { w.fn(s.data, s.at); } catch (e) { if (window.console && console.error) console.error('heretic live:', e); } // eslint-disable-line no-console -- a reader's fault is reported, never mistaken for a failed fetch
    }
    function load(s) {
      clearTimeout(s.timer); s.timer = 0;
      if (s.busy || !pace(s) || typeof fetch !== 'function') return;
      s.busy = true;
      fetchJSON(s.url, s.kind === 'feed' ? 10000 : 12000)
        .then(function (raw) {
          var data = s.kind === 'lastfm' ? parseLastfm(raw) : s.kind === 'spotify' ? parseSpotify(raw) : (raw && typeof raw === 'object' ? raw : null);
          if (!data) throw new Error('unexpected answer');
          s.data = data; s.at = Date.now(); s.failures = 0;
          s.watchers.slice().forEach(function (w) { if (!w.stopped) tell(w, s); });
        })
        .catch(function () {
          s.failures = Math.min(s.failures + 1, 5);
          s.watchers.slice().forEach(function (w) { if (!w.stopped && w.onfail) { try { w.onfail(s.failures); } catch (e) { /* a reader's own problem */ } } });
        })
        .then(function () { s.busy = false; schedule(s); });
    }
    /* fetch now if the answer is older than the current pace, otherwise wait for it */
    function freshen(s) {
      if (doc.hidden || s.busy) return;
      var base = pace(s);
      if (!base) { schedule(s); return; }
      /* a source that is failing keeps its back-off, even if it has never answered */
      if (!s.failures && (!s.at || Date.now() - s.at >= base)) load(s); else schedule(s);
    }
    doc.addEventListener('visibilitychange', function () {
      Object.keys(sources).forEach(function (id) {
        var s = sources[id];
        if (doc.hidden) { clearTimeout(s.timer); s.timer = 0; } else freshen(s);
      });
    });

    /* watch('feed' | 'lastfm' | 'spotify', url, { every, fn, onfail, owner, active }) → { activate(on), stop() }
       fn(data, at) is called with every new answer, and at once with the last one if
       there is one; onfail(failures), if given, after each failed fetch. An inactive reader
       still hears answers but does not set the pace. */
    function watch(kind, url, opts) {
      var s = source(kind, url);
      var w = { fn: opts.fn, onfail: opts.onfail || null, every: Math.max(5000, opts.every || 60000), owner: opts.owner || null, active: opts.active !== false, stopped: false };
      s.watchers.push(w);
      if (s.data) tell(w, s);
      freshen(s);
      return {
        activate: function (on) { w.active = !!on; freshen(s); },
        stop: function () { w.stopped = true; schedule(s); },
      };
    }

    /* The music, from Spotify through the worker and/or Last.fm, as one answer:
       music({ spotify: url, lastfm: { user, key }, every, fn, owner, active }) → { activate(on), stop() }
       fn({ now, played, count, playlist }, at). Spotify's song wins when both have one (the iPad on
       the Sonos only reaches Spotify); Last.fm still covers a phone that scrobbles. The
       played lists are merged newest first, each song once, at most four. `count` is
       Spotify's songs today, or null. A source that fails (Spotify not connected yet)
       simply adds nothing; one that has failed for a while (three of its turns, ninety
       seconds at least) keeps its played list but no longer has a song "on now" or a
       count, so the other source, or the played list alone, takes over. */
    function music(opts) {
      var got = { spotify: null, lastfm: null }, at = { spotify: 0, lastfm: 0 }, ws = [];
      var freshFor = Math.max(90000, 3 * (opts.every || 30000));
      function key(t) { return (t.artist + '|' + t.title).toLowerCase(); }
      function emit() {
        var sp = got.spotify, lf = got.lastfm, t = Date.now();
        if (!sp && !lf) return;
        var spFresh = !!sp && t - at.spotify < freshFor, lfFresh = !!lf && t - at.lastfm < freshFor;
        var now = (spFresh && sp.now) || (lfFresh && lf.now) || null;
        var all = [].concat(sp ? sp.played : [], lf ? lf.played : []).sort(function (a, b) { return (b.uts || 0) - (a.uts || 0); });
        var seen = {}, played = [];
        if (now) seen[key(now)] = 1;
        all.forEach(function (x) { var k = key(x); if (seen[k]) return; seen[k] = 1; if (played.length < 4) played.push(x); });
        opts.fn({ now: now, played: played, count: spFresh && sp.count != null ? sp.count : null, playlist: sp && sp.playlist ? sp.playlist : null }, Math.max(at.spotify, at.lastfm));
      }
      function hear(kind) { return function (data, when) { got[kind] = data; at[kind] = when; emit(); }; }
      var base = { every: opts.every, owner: opts.owner, active: opts.active, onfail: emit };
      if (opts.spotify) ws.push(watch('spotify', opts.spotify, Object.assign({ fn: hear('spotify') }, base)));
      if (opts.lastfm && opts.lastfm.user && opts.lastfm.key) ws.push(watch('lastfm', lastfmUrl(opts.lastfm.user, opts.lastfm.key), Object.assign({ fn: hear('lastfm') }, base)));
      return {
        activate: function (on) { ws.forEach(function (w) { w.activate(on); }); },
        stop: function () { ws.forEach(function (w) { w.stop(); }); },
      };
    }

    return { watch: watch, music: music, lastfmUrl: lastfmUrl, musicUrl: musicUrl, feedUrl: feedUrl, ago: ago };
  })();
  window.HereticLive = Live;

  /* ------------------------------------------------------------------ */
  /* What's playing: live from Spotify (through the worker) or Last.fm   */
  /* ------------------------------------------------------------------ */
  /* In live mode the strip arrives from Liquid showing a quiet line, never a typed
     song, so nothing the shop has not played can ever appear. Each answer from
     Last.fm is reduced to a signature; the strip is rebuilt only when that changes,
     so a check that finds the same song does not make the ticker jump. Nothing
     playing and no history shows the quiet line under the idle label. Everything
     from the API is inserted as text, never as markup. A failed check keeps whatever
     was last shown and tries again soon, then more slowly. */
  function initNowPlaying(root) {
    $$('.live[data-lastfm-user], .live[data-music-url]', root).forEach(function (np) {
      if (bound(np, 'Lastfm')) return;
      /* Two tracks carry the music: the desktop zone and the phone's single line. */
      var tracks = $$('[data-music-track]', np);
      var user = np.getAttribute('data-lastfm-user'), key = np.getAttribute('data-lastfm-key');
      var spotify = np.getAttribute('data-music-url');
      if (spotify && !/^https:\/\//i.test(spotify)) spotify = '';
      if (!tracks.length || (!spotify && !(user && key)) || typeof fetch !== 'function') return;

      var history = Math.min(4, Math.max(1, parseInt(np.getAttribute('data-history'), 10) || 2));
      var every = Math.max(20, parseInt(np.getAttribute('data-refresh'), 10) || 30) * 1000;
      var nowPrefix = np.getAttribute('data-now-prefix') || 'Now';
      var playedPrefix = np.getAttribute('data-played-prefix') || 'Just played';
      var quietText = np.getAttribute('data-quiet') || 'Nothing playing right now';
      var showAgo = np.getAttribute('data-ago') === 'true';
      var longLabel = $('.zone--music .label .long', np), shortLabel = $('.zone--music .label .short', np);
      var phoneLabel = $('[data-music-label]', np);
      var liveLabel = longLabel ? longLabel.textContent : '', liveShort = shortLabel ? shortLabel.textContent : '';
      var idleLabel = np.getAttribute('data-idle-label') || liveLabel, idleShort = np.getAttribute('data-idle-short') || liveShort;

      /* Pace. The scroll-time setting is read as the seconds a line of about three
         songs (a thousand pixels or so) takes to pass, so one song and four songs
         move at the same speed. A line short enough to fit its window holds still.
         A hidden track (the phone line on a desktop) has no width to measure; it is
         timed when the window changes and it is seen. */
      var views = tracks.map(function (track) {
        var seconds = parseFloat(getComputedStyle(track).getPropertyValue('--tick-s')) || 40;
        return { track: track, ticker: track.parentNode, pxPerSec: 1000 / seconds };
      });
      function retime(view) {
        var half = view.track.scrollWidth / 2;
        if (!half) return;
        view.ticker.classList.toggle('is-still', half <= view.ticker.clientWidth);
        view.track.style.setProperty('--tick-s', (half / view.pxPerSec).toFixed(1) + 's');
      }
      views.forEach(retime);

      var shownSignature = '';
      function ago(uts) { return uts ? Live.ago(uts * 1000) : ''; }

      function song(prefix, t, cls) {
        var span = doc.createElement('span');
        if (cls) span.className = cls;
        span.setAttribute('data-kind', 'music');
        if (prefix) span.appendChild(doc.createTextNode(prefix + ' · '));
        var b = doc.createElement('b');
        b.textContent = t.artist;
        span.appendChild(b);
        span.appendChild(doc.createTextNode(' — ' + t.title));
        if (showAgo && t.uts) {
          var when = doc.createElement('i');
          when.className = 'ago';
          when.textContent = ' · ' + ago(t.uts);
          span.appendChild(when);
        }
        return span;
      }

      function quiet() {
        var span = doc.createElement('span');
        span.setAttribute('data-kind', 'music');
        span.textContent = quietText;
        return span;
      }

      /* Only the music changes hands. The rest of the line (what's on the bar, people
         fed, typed messages) keeps the very nodes Liquid wrote, so a live fed number is
         never put back to the typed one. The new songs go in ahead of the first pass
         and, marked aria-hidden, ahead of the second. */
      function fill(view, music) {
        var track = view.track;
        $$(':scope > [data-kind="music"]', track).forEach(function (el) { track.removeChild(el); });
        var second = $$(':scope > [aria-hidden]', track)[0] || null;
        for (var pass = 0; pass < 2; pass++) {
          var before = pass ? second : track.firstChild;
          music.forEach(function (el) {
            var copy = el.cloneNode(true);
            if (pass) copy.setAttribute('aria-hidden', 'true');
            track.insertBefore(copy, before);
          });
        }
        retime(view);
      }

      /* Same songs as last time: only the "x min ago" wording moves on, in place. */
      function touchAges(played) {
        var ages = played.filter(function (t) { return t.uts; }).map(function (t) { return ' · ' + ago(t.uts); });
        views.forEach(function (view) {
          $$('.ago', view.track).forEach(function (el, i) { el.textContent = ages[i % Math.max(1, ages.length)] || ''; });
        });
      }

      function render(now, played) {
        var signature = (now ? 'N:' + now.artist + '|' + now.title : 'N:-') + played.map(function (t) { return '|P:' + t.artist + '|' + t.title; }).join('');
        if (signature === shownSignature) { if (showAgo) touchAges(played); return; }
        shownSignature = signature;
        var music = [];
        if (now) music.push(song(nowPrefix, now, 'now'));
        /* paused or stopped: the zone's own label says "Last played", so the songs go without a prefix */
        played.forEach(function (t) { music.push(song(now ? playedPrefix : '', t, '')); });
        if (!music.length) music.push(quiet());
        views.forEach(function (view) { fill(view, music); });
        np.classList.toggle('is-idle', !now);
        if (longLabel) longLabel.textContent = now ? liveLabel : idleLabel;
        if (shortLabel) shortLabel.textContent = now ? liveShort : idleShort;
        if (phoneLabel) phoneLabel.textContent = now ? liveShort : idleShort;
      }

      /* One poller for the whole page (see Live above): the board, when it is open,
         hears the same answers rather than asking again. */
      Live.music({
        spotify: spotify || null, lastfm: user && key ? { user: user, key: key } : null,
        every: every, owner: np,
        fn: function (music) { render(music.now, music.played.slice(0, history)); },
      });
      onPage('resize', np, function () { views.forEach(retime); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* People fed: one small JSON feed updates every number on the page   */
  /* ------------------------------------------------------------------ */
  /* The feed address lives in theme settings and is printed on <body>. The page
     arrives with the typed numbers already in place; when the feed answers, every
     element marked data-fed="today" or "year" takes the live value, including the
     Daily Count animation, which reads data-count when it starts. */
  function initFedFeed() {
    var url = body.getAttribute('data-fed-feed');
    if (!url || !/^https:\/\//i.test(url) || typeof fetch !== 'function') return;
    if (body.dataset.boundFed) return;
    body.dataset.boundFed = '1';

    /* Only a real number may replace the typed count: null, a string or a missing
       field leaves the page as it is rather than animating every counter to zero. */
    function apply(key, value) {
      if (typeof value !== 'number' || !isFinite(value)) return;
      var n = Math.max(0, Math.floor(value));
      $$('[data-fed="' + key + '"]').forEach(function (el) {
        var shown = shownCount(el, toInt(String(el.textContent).replace(/[^\d]/g, ''), 0));
        el.dataset.count = String(n);
        tweenCount(el, shown, n, 900);
      });
    }
    /* the shared poller: every minute, or every 45 seconds while the LIVE board is open */
    Live.watch('feed', Live.feedUrl(url), {
      every: 60000,
      fn: function (data) {
        if ('today' in data) apply('today', data.today);
        if ('year' in data) apply('year', data.year);
      },
    });
  }

  /* ------------------------------------------------------------------ */
  /* Brew guides: on a phone each method folds under its name             */
  /* Brew recipes on a phone. The markup is plain headings and recipes. On a narrow screen
     the heading's text is moved into a button that opens and closes the recipe; leaving
     the narrow screen puts the text back and shows everything, so wide screens never see
     a button. */
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 759px)') : null;
  function initBrewFolds(root) {
    $$('[data-brew]', root).forEach(function (brew) {
      if (bound(brew, 'Brew')) return;
      var title = $('[data-brew-title]', brew), recipe = $('[data-brew-body]', brew);
      if (!title || !recipe || !PHONE) return;
      var button = null;
      function set(open) {
        recipe.hidden = !open;
        if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function fold() {
        if (button) return;
        button = doc.createElement('button');
        button.type = 'button';
        button.className = 'brew__toggle';
        button.setAttribute('aria-controls', recipe.id);
        while (title.firstChild) button.appendChild(title.firstChild);
        title.appendChild(button);
        button.addEventListener('click', function () { set(recipe.hidden); });
        set(false);
      }
      function unfold() {
        if (!button) return;
        while (button.firstChild) title.appendChild(button.firstChild);
        title.removeChild(button);
        button = null;
        recipe.hidden = false;
      }
      function apply() { if (PHONE.matches) fold(); else unfold(); }
      onPage('resize', brew, apply);
      apply();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Newsletter: join in place, no page reload                            */
  /* ------------------------------------------------------------------ */
  /* Shopify's customer form answers a post with a redirect: back to the page with
     customer_posted=true on success, to /challenge when it wants its spam check, or
     the page again with the errors written into it. The form posts itself with
     fetch and reads that answer, so the reader never leaves the spot they were on.
     Anything unexpected hands the post back to the browser, which still works. */
  function initJoin(root) {
    $$('form.join', root).forEach(function (form) {
      if (bound(form, 'Join')) return;
      var ok = $('[data-join-success]', form), bad = $('[data-join-error]', form);
      var button = $('button[type="submit"]', form), email = $('input[type="email"]', form);
      if (!ok || !bad || !button || !email || typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      function busy(on) {
        form.classList.toggle('is-busy', on);
        button.disabled = on;
        form.setAttribute('aria-busy', on ? 'true' : 'false');
      }
      function show(el, text) { el.textContent = text; }
      /* success replaces the field in place: keep the box exactly as tall as it was */
      function joined() { form.style.setProperty('--join-h', (form.clientHeight || 0) + 'px'); email.value = ''; show(ok, ok.getAttribute('data-text') || 'Thank you.'); }
      function native() { form.submit(); }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (button.disabled) return;
        show(ok, ''); show(bad, '');
        busy(true);
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var cutoff = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow', headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) {
            var where = r.url || '';
            if (/\/challenge(\?|#|$)/.test(where)) { native(); return null; }
            if (/[?&]customer_posted=true/.test(where)) {
              joined();
              return true;
            }
            return r.text().then(function (html) {
              var page = new DOMParser().parseFromString(html, 'text/html');
              var again = page.getElementById(form.id);
              var err = again && again.querySelector('[data-join-error]');
              var text = err ? err.textContent.trim() : '';
              if (text) { show(bad, text); return true; }
              if (r.ok && again && again.querySelector('[data-join-success]') && again.querySelector('[data-join-success]').textContent.trim()) {
                joined();
                return true;
              }
              native(); return null;
            });
          })
          .catch(function (err) {
            /* timed out: Shopify may already have the address, so say so rather than post it a second time */
            if (err && err.name === 'AbortError') { show(bad, 'That took too long to go through. Try again in a minute.'); return true; }
            native(); return null; /* null: the browser is submitting, keep Join disabled */
          })
          .then(function (done) { clearTimeout(cutoff); if (done !== null) busy(false); });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* The heart under a Journal post: counts from the people-fed worker    */
  /* (/likes). The row stays hidden until the worker answers. This browser */
  /* remembers what it liked, so a reload doesn't like twice.              */
  /* ------------------------------------------------------------------ */
  var LIKED_KEY = 'heretic-liked';
  function likedList() {
    try {
      var v = JSON.parse(window.localStorage.getItem(LIKED_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function saveLiked(list) {
    try { window.localStorage.setItem(LIKED_KEY, JSON.stringify(list.slice(-200))); } catch (e) { /* private window: the heart still works for this visit */ }
  }
  function likeText(n) {
    if (n <= 0) return 'Be the first';
    return n.toLocaleString('en-US') + (n === 1 ? ' heart' : ' hearts');
  }
  function initLikes(root) {
    var feed = body.getAttribute('data-fed-feed');
    $$('[data-like-row]', root).forEach(function (row) {
      if (bound(row, 'Like') || !feed || !window.fetch) return;
      var btn = $('[data-like]', row);
      var out = $('[data-like-count]', row);
      var post = btn ? btn.getAttribute('data-like') : '';
      if (!btn || !out || !/^[a-z0-9-]+\/[a-z0-9-]+$/.test(post)) return;
      var url = feed.replace(/\/+$/, '') + '/likes';
      var count = 0;
      var busy = false;
      function show() {
        btn.setAttribute('aria-pressed', likedList().indexOf(post) !== -1 ? 'true' : 'false');
        out.textContent = likeText(count);
      }
      function setLiked(on) {
        var list = likedList();
        var i = list.indexOf(post);
        if (on && i === -1) list.push(post);
        if (!on && i !== -1) list.splice(i, 1);
        saveLiked(list);
      }
      fetch(url + '?posts=' + encodeURIComponent(post))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.counts || typeof d.counts[post] !== 'number') return;
          count = d.counts[post];
          show();
          row.hidden = false;
        })
        .catch(function () { /* no worker, no heart */ });
      btn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        var was = likedList().indexOf(post) !== -1;
        var now = !was;
        setLiked(now);
        count = Math.max(0, count + (now ? 1 : -1));
        show();
        if (now && !reduceMotion()) {
          btn.classList.remove('is-popping');
          void btn.offsetWidth; /* restart the pop */
          btn.classList.add('is-popping');
        }
        fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ post: post, like: now }) })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (d) { if (d && typeof d.count === 'number') { count = d.count; show(); } })
          .catch(function () {
            /* didn't reach the worker: put things back as they were */
            setLiked(was);
            count = Math.max(0, count + (now ? -1 : 1));
            show();
          })
          .then(function () { busy = false; });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot, and re-boot whatever the theme editor re-renders              */
  /* ------------------------------------------------------------------ */
  function init(root) {
    refreshRefs();
    initCounters(root);
    initRoastLog(root);
    initSheets(root);
    initRowStart(root);
    initOriginMap(root);
    initFin(root);
    initBackgroundVideo(root);
    initSteam(root);
    initGivebutter(root);
    initNowPlaying(root);
    initBrewFolds(root);
    initJoin(root);
    initLikes(root);
    initFedFeed();
    $$('[data-product-form]', root).forEach(function (form) { if (!bound(form, 'Variants')) updateVariant(form); });
    onScroll();
  }

  init(doc);

  if (reduceMQ && reduceMQ.addEventListener) {
    reduceMQ.addEventListener('change', function () { init(doc); });
  }

  doc.addEventListener('shopify:section:load', function (e) { init(e.target || doc); });
  doc.addEventListener('shopify:section:unload', function (e) {
    /* the editor is replacing a section: an open drawer inside it is gone, so its flags go too */
    var t = e && e.target;
    if (t && t.querySelector) {
      if (cartIsOpen && t.querySelector('#cart-drawer')) { cartIsOpen = false; body.classList.remove('cart-open'); }
      if (navIsOpen && t.querySelector('#nav-drawer')) { navIsOpen = false; body.classList.remove('nav-open'); }
    }
    refreshRefs(); onScroll();
  });
  doc.addEventListener('shopify:section:select', function (e) {
    var target = e.target || null;
    if (target && target.querySelector && target.querySelector('#cart-drawer')) openCart();
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var target = e.target || null;
    if (target && target.querySelector && target.querySelector('#cart-drawer')) closeCart();
  });
})();
